// extracted by mini-css-extract-plugin
module.exports = {"contact__item_wrapper":"myContact_contact__item_wrapper__1-S5D","tag":"myContact_tag__2D6dR"};